import React from 'react';
import { PhoneIcon, MailIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      {/* Hero Section */}
      <div className="bg-blue-50 py-16 px-4 sm:px-6 lg:px-8" data-id="element-1">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-blue-900 mb-4" data-id="element-3">
            IT der bare virker – så du kan fokusere på forretningen
          </h1>
          <p className="text-xl text-blue-800 mb-6" data-id="element-4">
            Vi hjælper med at finde de værktøjer du skal bruge for at drive din
            virksomhed - og vi gør det billigt og overskueligt.
          </p>
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-8" data-id="element-5"></div>
        </div>
      </div>
      {/* Services Section */}
      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-6">
        <div className="max-w-4xl mx-auto" data-id="element-7">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-10 text-center" data-id="element-8">
            Vi hjælper dig med
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-9">
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm flex" data-id="element-10">
              <CheckIcon className="text-blue-500 mr-4 h-6 w-6 flex-shrink-0" data-id="element-11" />
              <p className="text-gray-700" data-id="element-12">
                At vælge de rigtige systemer (mail, kalender, booking, betaling)
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm flex" data-id="element-13">
              <CheckIcon className="text-blue-500 mr-4 h-6 w-6 flex-shrink-0" data-id="element-14" />
              <p className="text-gray-700" data-id="element-15">
                At få dem sat rigtigt op fra starten
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm flex" data-id="element-16">
              <CheckIcon className="text-blue-500 mr-4 h-6 w-6 flex-shrink-0" data-id="element-17" />
              <p className="text-gray-700" data-id="element-18">
                Backup og sikkerhed, så du ikke mister vigtige data
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm flex" data-id="element-19">
              <CheckIcon className="text-blue-500 mr-4 h-6 w-6 flex-shrink-0" data-id="element-20" />
              <p className="text-gray-700" data-id="element-21">
                At overholde reglerne (GDPR, løn, skat m.m.)
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Process Section */}
      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-22">
        <div className="max-w-4xl mx-auto" data-id="element-23">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-10 text-center" data-id="element-24">
            Sådan fungerer det
          </h2>
          <div className="space-y-8 md:space-y-0 md:grid md:grid-cols-3 md:gap-8" data-id="element-25">
            <div className="text-center" data-id="element-26">
              <div className="bg-blue-500 text-white h-12 w-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold" data-id="element-27">
                1
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-28">
                Gratis gennemgang
              </h3>
              <p className="text-gray-600" data-id="element-29">Vi mødes og ser på dine behov.</p>
            </div>
            <div className="text-center" data-id="element-30">
              <div className="bg-blue-500 text-white h-12 w-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold" data-id="element-31">
                2
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-32">
                Opsætning
              </h3>
              <p className="text-gray-600" data-id="element-33">
                Vi sætter de nødvendige systemer op og får dem til at spille
                sammen.
              </p>
            </div>
            <div className="text-center" data-id="element-34">
              <div className="bg-blue-500 text-white h-12 w-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold" data-id="element-35">
                3
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-36">
                Løbende hjælp
              </h3>
              <p className="text-gray-600" data-id="element-37">
                Du kan ringe, hvis noget driller, eller få faste timer hver
                måned.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Why Us Section */}
      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-38">
        <div className="max-w-4xl mx-auto" data-id="element-39">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-10 text-center" data-id="element-40">
            Hvorfor os?
          </h2>
          <div className="space-y-6" data-id="element-41">
            <div className="flex items-start" data-id="element-42">
              <div className="flex-shrink-0" data-id="element-43">
                <CheckIcon className="h-6 w-6 text-blue-500" data-id="element-44" />
              </div>
              <div className="ml-3" data-id="element-45">
                <p className="text-lg text-gray-700" data-id="element-46">
                  Mange års erfaring med IT og software.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-47">
              <div className="flex-shrink-0" data-id="element-48">
                <CheckIcon className="h-6 w-6 text-blue-500" data-id="element-49" />
              </div>
              <div className="ml-3" data-id="element-50">
                <p className="text-lg text-gray-700" data-id="element-51">
                  Vi taler et sprog, alle kan forstå.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-52">
              <div className="flex-shrink-0" data-id="element-53">
                <CheckIcon className="h-6 w-6 text-blue-500" data-id="element-54" />
              </div>
              <div className="ml-3" data-id="element-55">
                <p className="text-lg text-gray-700" data-id="element-56">
                  Vi vil hellere forebygge problemer end at slukke brande.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-57">
              <div className="flex-shrink-0" data-id="element-58">
                <CheckIcon className="h-6 w-6 text-blue-500" data-id="element-59" />
              </div>
              <div className="ml-3" data-id="element-60">
                <p className="text-lg text-gray-700" data-id="element-61">
                  Vi kræver først betaling når det hele kører som forventet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CTA Section */}
      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-blue-50" data-id="element-62">
        <div className="max-w-4xl mx-auto text-center" data-id="element-63">
          <h2 className="text-2xl md:text-3xl font-semibold text-blue-900 mb-8" data-id="element-64">
            Book en <span className="underline" data-id="element-65">gratis</span> gennemgang
          </h2>
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8" data-id="element-66">
            <a href="tel:22572045" className="flex items-center justify-center text-lg text-blue-700 hover:text-blue-800 transition-colors" data-id="element-67">
              <PhoneIcon className="h-6 w-6 mr-2" data-id="element-68" />
              <span data-id="element-69">22572045</span>
            </a>
            <a href="mailto:kontakt@donut-it.dk" className="flex items-center justify-center text-lg text-blue-700 hover:text-blue-800 transition-colors" data-id="element-70">
              <MailIcon className="h-6 w-6 mr-2" data-id="element-71" />
              <span data-id="element-72">kontakt@donut-it.dk</span>
            </a>
          </div>
          <div className="mt-10" data-id="element-73">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-lg shadow-md transition-colors flex items-center mx-auto print:hidden" data-id="element-74">
              Kontakt os i dag
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-75" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}